export const DEFAULT_IMAGE = '/img/illustration_activite_base-BLEU.png'
